import { render, staticRenderFns } from "./StatesTable.vue?vue&type=template&id=2147d24e"
import script from "./StatesTable.vue?vue&type=script&lang=js"
export * from "./StatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports